import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installTattvaTestConsole } from "@/lib/tattva/tattva-test-console";
import { installAlertsTestConsole } from "@/lib/sacred-alerts/alerts-test-console";
import { installJourneyTestConsole } from "@/lib/sacred-journey/journey-test-console";
import { installJourneyValidationConsole } from "@/lib/sacred-journey/journey-validation-console";
import { installAcharyaTestConsole } from "@/lib/acharya/acharya-test-console";

installTattvaTestConsole();
installAlertsTestConsole();
installJourneyTestConsole();
installJourneyValidationConsole();
installAcharyaTestConsole();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
